import styled from 'styled-components';

export const ParcelLockerWrapper = styled.div`
  padding-left: ${({ theme }) => theme.spacing(3)};
  padding-right: ${({ theme }) => theme.spacing(3)};
`;
